// extracted by css-extract-rspack-plugin
export default {"sectionLabel":"sectionLabel-FW_Gne","campaignLabel":"campaignLabel-Hat1jm","checkboxRow":"checkboxRow-E5yH_i","checkboxInput":"checkboxInput-fXxk2O"};